import DoneIcon from "@material-ui/icons/Done";
import clsx from "clsx";
import React, { FC } from "react";
import { makeStyles } from "@material-ui/core/styles";

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: "#646464",
    zIndex: 1,
    color: "#fff",
    width: 30,
    height: 30,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  active: {
    backgroundColor: "#FF7A59",
  },
  completed: {
    backgroundColor: "#FF714E",
  },
  doneIcon: {
    width: 16,
    height: 16,
  },
});

type StepIconProps = {
  active: boolean;
  completed: boolean;
  icon: JSX.Element;
};

const StepIcon: FC<StepIconProps> = ({ active, completed, icon }) => {
  const classes = useColorlibStepIconStyles();

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {completed ? <DoneIcon className={classes.doneIcon} /> : icon}
    </div>
  );
};

export default StepIcon;
